import { ReactElement } from 'react'
import AdminLayout from '../../design/WebAdmin/_layouts/AdminLayout'
import { NextPageWithLayout } from '../_app'
import { Typography } from '@mui/material'

const AdminIndex: NextPageWithLayout = () => {
  return (
    <Typography>Admin dashboard</Typography>
  )
}

export default AdminIndex

// ----------------------------------------------------------------------

AdminIndex.getLayout = function getLayout(page: ReactElement) {
  return <AdminLayout pageTitle={"Dashboard"}>{page}</AdminLayout>
}
